import { withInstall } from '../../utils/install';
import BottomNavItem from './index.vue';

export const IvueBottomNavItem = withInstall(BottomNavItem);
export default IvueBottomNavItem;

export * from './index.vue';
